// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== B-book lists: labelled toolbars, paging, tables that scroll instead of clipping ===== */

.b_book_page .b_book_toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: var(--bb-space-3) var(--bb-space-4);
}

.b_book_page .b_book_toolbar_field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.b_book_page .b_book_toolbar_search {
    flex: 1 1;
    min-width: 220px;
    max-width: 360px;
}

.b_book_page .b_book_toolbar_field label {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
}

.b_book_page .b_book_toolbar_field input,
.b_book_page .b_book_toolbar_field select {
    min-height: 36px;
    background-color: var(--bg);
}

.b_book_page .b_book_toolbar_field select {
    min-width: 90px;
    cursor: pointer;
}

.b_book_page .b_book_count {
    display: inline-block;
    margin-left: 6px;
    padding: 2px 8px;
    border-radius: 999px;
    background-color: var(--bg);
    border: 1px solid var(--border);
    font-size: 13px;
    font-weight: 600;
    vertical-align: middle;
    color: var(--bb-soft);
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_pager {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--bb-space-3);
    font-size: 13px;
    color: var(--bb-soft);
}

/* the shared table clips every cell (fixed layout + ellipsis): here the table takes the width it needs and its container scrolls sideways */
.b_book_page .tableau_container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.b_book_page .tableau_table {
    table-layout: auto;
    width: 100%;
}

.b_book_page .tableau_head_item_th,
.b_book_page .tableau_body_item {
    overflow: visible;
    text-overflow: clip;
}

.b_book_page .tableau_body_item:last-child,
.b_book_page .tableau_head_item_th:last-child {
    text-align: right;
}

/* adding to the list and filtering it are two different jobs: keep them visibly apart */
.b_book_page .b_book_add_row + .b_book_toolbar {
    padding-top: var(--bb-space-4);
    border-top: 1px solid var(--border);
}

.b_book_page .table-container .b_book_pager {
    padding-top: var(--bb-space-3);
}

.b_book_page .b_book_row_actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--bb-space-2);
}

/* the asset's leverages: one chip each, locked up to LMAX's margin, removable beyond it, and the field to add one */
.b_book_page .b_book_extra_leverages {
    display: flex;
    flex-direction: column;
    gap: var(--bb-space-2);
    min-width: 280px;
}

.b_book_page .b_book_chip_locked {
    color: var(--text-muted, inherit);
    background-color: var(--bg);
    opacity: 0.85;
}

.b_book_page .b_book_chip_locked svg {
    opacity: 0.6;
}

.b_book_page .b_book_chip_remove:disabled {
    cursor: not-allowed;
    opacity: 0.35;
}

.b_book_page .b_book_chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--bb-space-2);
}

.b_book_page .b_book_chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border: 1px solid var(--border);
    border-radius: 999px;
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_chip_remove {
    border: 0;
    background: none;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    padding: 0 2px;
}

.b_book_page .b_book_chip_input {
    width: 90px;
    min-height: 32px;
}


/* ===== responsive tables: wide screens spread the columns, laptops let cells wrap, phones stack each row as a card ===== */

.b_book_page .b_book_num {
    white-space: nowrap; /* a figure never breaks, whatever the cell does */
}

@media (max-width: 1500px) {
    .b_book_page .tableau_head_item_th,
    .b_book_page .tableau_body_item {
        padding: 10px 8px;
        white-space: normal;
    }

    .b_book_page .tableau_head_item_th {
        line-height: 1.25;
    }

    .b_book_page .b_book_cell_hint {
        white-space: normal;
    }
}

@media (max-width: 900px) {
    .b_book_page .tableau_table,
    .b_book_page .tableau_table tbody,
    .b_book_page .tableau_table tr,
    .b_book_page .tableau_table td {
        display: block;
        width: 100%;
        min-width: 0;
    }

    .b_book_page .tableau_table thead {
        display: none; /* each cell carries its own label below */
    }

    .b_book_page .tableau_body:before {
        display: none;
    }

    .b_book_page .tableau_body_row {
        margin-bottom: var(--bb-space-3);
        padding: var(--bb-space-2) var(--bb-space-3);
        border: 1px solid var(--border);
        border-radius: var(--bb-radius-md);
        background-color: var(--bg-card);
    }

    .b_book_page .tableau_body tr:nth-child(even) {
        background-color: var(--bg-card);
    }

    .b_book_page .tableau_table td.tableau_body_item { /* outranks the block rule above */
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--bb-space-3);
        padding: 8px 0;
        border-bottom: 1px solid var(--border-light);
        overflow: visible;
        text-overflow: clip;
        text-align: right;
    }

    .b_book_page .tableau_table td.tableau_body_item:last-child {
        border-bottom: 0;
    }

    .b_book_page .tableau_body_item[data-label]::before {
        content: attr(data-label);
        flex: 0 0 auto;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: var(--text-secondary);
        text-align: left;
    }

    .b_book_page .tableau_body_item .b_book_stack {
        align-items: flex-end;
    }

    .b_book_page .tableau_body_item .b_book_row_actions {
        justify-content: flex-end;
        flex-wrap: wrap;
    }

    .b_book_page .tableau_body_item .b_book_extra_leverages {
        min-width: 0;
        align-items: flex-end;
    }

    .b_book_page .tableau_body_item .b_book_chips {
        justify-content: flex-end;
    }
}

@media (max-width: 900px) {
    /* a cell with chips and a field: label above, content left-aligned, instead of a narrow right-hand column */
    .b_book_page .tableau_table td.tableau_body_item:has(.b_book_extra_leverages) {
        flex-direction: column;
        align-items: stretch;
        text-align: left;
    }

    .b_book_page .tableau_table td.tableau_body_item:has(.b_book_extra_leverages) .b_book_extra_leverages,
    .b_book_page .tableau_table td.tableau_body_item:has(.b_book_extra_leverages) .b_book_chips {
        align-items: flex-start;
        justify-content: flex-start;
    }
}


/* sortable lists: the headers are buttons in all but name */
.b_book_page .b_book_sortable .tableau_head_item_th {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.b_book_page .b_book_sortable .tableau_head_item_th:hover {
    color: var(--text-primary);
}

.b_book_page .b_book_sortable .tableau_head_item_th:last-child {
    cursor: default; /* the action column */
}
`, "",{"version":3,"sources":["webpack://./src/pages/bBook/bBookLists.css"],"names":[],"mappings":"AAAA,gGAAgG;;AAEhG;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;IAEI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;IAC3B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;AACzB;;AAEA,4IAA4I;AAC5I;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA,wFAAwF;AACxF;IACI,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,oHAAoH;AACpH;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,+BAA+B;IAC/B,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;;AAGA,4HAA4H;;AAE5H;IACI,mBAAmB,EAAE,kDAAkD;AAC3E;;AAEA;IACI;;QAEI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;;;;QAII,cAAc;QACd,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa,EAAE,0CAA0C;IAC7D;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gCAAgC;QAChC,4CAA4C;QAC5C,+BAA+B;QAC/B,kCAAkC;QAClC,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA,mDAAmD,kCAAkC;QACjF,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,sBAAsB;QACtB,cAAc;QACd,4CAA4C;QAC5C,iBAAiB;QACjB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;QACzB,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,4GAA4G;IAC5G;QACI,sBAAsB;QACtB,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;;QAEI,uBAAuB;QACvB,2BAA2B;IAC/B;AACJ;;;AAGA,4DAA4D;AAC5D;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe,EAAE,sBAAsB;AAC3C","sourcesContent":["/* ===== B-book lists: labelled toolbars, paging, tables that scroll instead of clipping ===== */\n\n.b_book_page .b_book_toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: var(--bb-space-3) var(--bb-space-4);\n}\n\n.b_book_page .b_book_toolbar_field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.b_book_page .b_book_toolbar_search {\n    flex: 1;\n    min-width: 220px;\n    max-width: 360px;\n}\n\n.b_book_page .b_book_toolbar_field label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_toolbar_field input,\n.b_book_page .b_book_toolbar_field select {\n    min-height: 36px;\n    background-color: var(--bg);\n}\n\n.b_book_page .b_book_toolbar_field select {\n    min-width: 90px;\n    cursor: pointer;\n}\n\n.b_book_page .b_book_count {\n    display: inline-block;\n    margin-left: 6px;\n    padding: 2px 8px;\n    border-radius: 999px;\n    background-color: var(--bg);\n    border: 1px solid var(--border);\n    font-size: 13px;\n    font-weight: 600;\n    vertical-align: middle;\n    color: var(--bb-soft);\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_pager {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: var(--bb-space-3);\n    font-size: 13px;\n    color: var(--bb-soft);\n}\n\n/* the shared table clips every cell (fixed layout + ellipsis): here the table takes the width it needs and its container scrolls sideways */\n.b_book_page .tableau_container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.b_book_page .tableau_table {\n    table-layout: auto;\n    width: 100%;\n}\n\n.b_book_page .tableau_head_item_th,\n.b_book_page .tableau_body_item {\n    overflow: visible;\n    text-overflow: clip;\n}\n\n.b_book_page .tableau_body_item:last-child,\n.b_book_page .tableau_head_item_th:last-child {\n    text-align: right;\n}\n\n/* adding to the list and filtering it are two different jobs: keep them visibly apart */\n.b_book_page .b_book_add_row + .b_book_toolbar {\n    padding-top: var(--bb-space-4);\n    border-top: 1px solid var(--border);\n}\n\n.b_book_page .table-container .b_book_pager {\n    padding-top: var(--bb-space-3);\n}\n\n.b_book_page .b_book_row_actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: var(--bb-space-2);\n}\n\n/* the asset's leverages: one chip each, locked up to LMAX's margin, removable beyond it, and the field to add one */\n.b_book_page .b_book_extra_leverages {\n    display: flex;\n    flex-direction: column;\n    gap: var(--bb-space-2);\n    min-width: 280px;\n}\n\n.b_book_page .b_book_chip_locked {\n    color: var(--text-muted, inherit);\n    background-color: var(--bg);\n    opacity: 0.85;\n}\n\n.b_book_page .b_book_chip_locked svg {\n    opacity: 0.6;\n}\n\n.b_book_page .b_book_chip_remove:disabled {\n    cursor: not-allowed;\n    opacity: 0.35;\n}\n\n.b_book_page .b_book_chips {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: var(--bb-space-2);\n}\n\n.b_book_page .b_book_chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 8px;\n    border: 1px solid var(--border);\n    border-radius: 999px;\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_chip_remove {\n    border: 0;\n    background: none;\n    cursor: pointer;\n    font-size: 16px;\n    line-height: 1;\n    padding: 0 2px;\n}\n\n.b_book_page .b_book_chip_input {\n    width: 90px;\n    min-height: 32px;\n}\n\n\n/* ===== responsive tables: wide screens spread the columns, laptops let cells wrap, phones stack each row as a card ===== */\n\n.b_book_page .b_book_num {\n    white-space: nowrap; /* a figure never breaks, whatever the cell does */\n}\n\n@media (max-width: 1500px) {\n    .b_book_page .tableau_head_item_th,\n    .b_book_page .tableau_body_item {\n        padding: 10px 8px;\n        white-space: normal;\n    }\n\n    .b_book_page .tableau_head_item_th {\n        line-height: 1.25;\n    }\n\n    .b_book_page .b_book_cell_hint {\n        white-space: normal;\n    }\n}\n\n@media (max-width: 900px) {\n    .b_book_page .tableau_table,\n    .b_book_page .tableau_table tbody,\n    .b_book_page .tableau_table tr,\n    .b_book_page .tableau_table td {\n        display: block;\n        width: 100%;\n        min-width: 0;\n    }\n\n    .b_book_page .tableau_table thead {\n        display: none; /* each cell carries its own label below */\n    }\n\n    .b_book_page .tableau_body:before {\n        display: none;\n    }\n\n    .b_book_page .tableau_body_row {\n        margin-bottom: var(--bb-space-3);\n        padding: var(--bb-space-2) var(--bb-space-3);\n        border: 1px solid var(--border);\n        border-radius: var(--bb-radius-md);\n        background-color: var(--bg-card);\n    }\n\n    .b_book_page .tableau_body tr:nth-child(even) {\n        background-color: var(--bg-card);\n    }\n\n    .b_book_page .tableau_table td.tableau_body_item { /* outranks the block rule above */\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: var(--bb-space-3);\n        padding: 8px 0;\n        border-bottom: 1px solid var(--border-light);\n        overflow: visible;\n        text-overflow: clip;\n        text-align: right;\n    }\n\n    .b_book_page .tableau_table td.tableau_body_item:last-child {\n        border-bottom: 0;\n    }\n\n    .b_book_page .tableau_body_item[data-label]::before {\n        content: attr(data-label);\n        flex: 0 0 auto;\n        font-size: 11px;\n        font-weight: 600;\n        letter-spacing: 0.04em;\n        text-transform: uppercase;\n        color: var(--text-secondary);\n        text-align: left;\n    }\n\n    .b_book_page .tableau_body_item .b_book_stack {\n        align-items: flex-end;\n    }\n\n    .b_book_page .tableau_body_item .b_book_row_actions {\n        justify-content: flex-end;\n        flex-wrap: wrap;\n    }\n\n    .b_book_page .tableau_body_item .b_book_extra_leverages {\n        min-width: 0;\n        align-items: flex-end;\n    }\n\n    .b_book_page .tableau_body_item .b_book_chips {\n        justify-content: flex-end;\n    }\n}\n\n@media (max-width: 900px) {\n    /* a cell with chips and a field: label above, content left-aligned, instead of a narrow right-hand column */\n    .b_book_page .tableau_table td.tableau_body_item:has(.b_book_extra_leverages) {\n        flex-direction: column;\n        align-items: stretch;\n        text-align: left;\n    }\n\n    .b_book_page .tableau_table td.tableau_body_item:has(.b_book_extra_leverages) .b_book_extra_leverages,\n    .b_book_page .tableau_table td.tableau_body_item:has(.b_book_extra_leverages) .b_book_chips {\n        align-items: flex-start;\n        justify-content: flex-start;\n    }\n}\n\n\n/* sortable lists: the headers are buttons in all but name */\n.b_book_page .b_book_sortable .tableau_head_item_th {\n    cursor: pointer;\n    user-select: none;\n}\n\n.b_book_page .b_book_sortable .tableau_head_item_th:hover {\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_sortable .tableau_head_item_th:last-child {\n    cursor: default; /* the action column */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
